import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Printer } from 'lucide-react';
import { siteSettings as fallbackSettings, navItems, logo } from '../data/mock';
import { useContent } from '../context/ContentContext';

const Footer = () => {
  const { siteSettings = fallbackSettings } = useContent();
  return (
    <footer className="bg-brand-bluedeep text-white/80">
      <div className="container-c pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="inline-block bg-white rounded-lg px-4 py-3 mb-4 shadow-md">
              <img src={logo} alt="Comfort Air Mechanical" className="h-10 w-auto" />
            </div>
            <p className="text-sm leading-relaxed">{siteSettings.tagline}. Proudly serving the Cortez & Four Corners area of Southwest Colorado.</p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-white mb-4">Get In Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3"><MapPin size={17} className="text-brand-green mt-0.5 shrink-0" /><span>{siteSettings.address}<br />{siteSettings.city}</span></li>
              <li className="flex items-center gap-3"><Phone size={17} className="text-brand-green shrink-0" /><a href={`tel:${siteSettings.phoneRaw}`} className="hover:text-white">{siteSettings.phone}</a></li>
              <li className="flex items-center gap-3"><Printer size={17} className="text-brand-green shrink-0" /><span>{siteSettings.fax}</span></li>
              <li className="flex items-center gap-3"><Mail size={17} className="text-brand-green shrink-0" /><a href={`mailto:${siteSettings.email}`} className="hover:text-white">{siteSettings.email}</a></li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {navItems.map((n) => (
                <li key={n.label}><Link to={n.path} className="hover:text-brand-green transition-colors">{n.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-display font-bold text-white mb-4 flex items-center gap-2"><Clock size={18} className="text-brand-green" /> Business Hours</h4>
            <ul className="space-y-2 text-sm">
              {siteSettings.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-4"><span>{h.day}</span><span className="text-white font-medium">{h.time}</span></li>
              ))}
            </ul>
            <div className="mt-4 inline-block bg-brand-green/20 border border-brand-green/40 rounded-lg px-3 py-2 text-brand-green text-xs font-semibold">
              {siteSettings.emergencyNote}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <span>© {new Date().getFullYear()} {siteSettings.companyFull}, LLC. All Rights Reserved.</span>
          <span>Heating · Air Conditioning · Sheet Metal · Refrigeration</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
